import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/reset.css'
import './styles/variables.css'
import './index.css'
import App from './App'
import '@rockstar/registration-component/dist/index.cjs.css'
import { ControlModalProvider } from '@rockstar/registration-component'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <ControlModalProvider>
            <App />
        </ControlModalProvider>
    </React.StrictMode>,
)
